import { Id } from "../../../shared/models/types";

export class CheckedFobLocationsDownloadRequest {
    ids: Id[];

    constructor(ids: Id[], areAllProductsChecked: boolean) {
        this.ids = areAllProductsChecked ? null : ids;
      }
}